module.exports = "/static/assets/5d1ae91085a7e2014a3a09261ff0526b.png";